import { AxiosRequestConfig, AxiosResponse } from 'axios';

import {
  IBillingPortalResponse,
  ICheckoutResponse,
  IBillingStatusResponse,
} from './billing.interface';

import { axiosApiInstance } from 'services/config';

class BillingApi {
  async getStatus(config?: AxiosRequestConfig): Promise<IBillingStatusResponse> {
    const response: AxiosResponse<IBillingStatusResponse> = config
      ? await axiosApiInstance.get('/billing/status', config)
      : await axiosApiInstance.get('/billing/status');
    return response.data;
  }

  async createCheckout(config?: AxiosRequestConfig): Promise<ICheckoutResponse> {
    const response: AxiosResponse<ICheckoutResponse> = config
      ? await axiosApiInstance.post('/billing/checkout', undefined, config)
      : await axiosApiInstance.post('/billing/checkout');
    return response.data;
  }

  async cancelSubscription(config?: AxiosRequestConfig): Promise<IBillingStatusResponse> {
    const response: AxiosResponse<IBillingStatusResponse> = config
      ? await axiosApiInstance.post('/billing/cancel', undefined, config)
      : await axiosApiInstance.post('/billing/cancel');
    return response.data;
  }

  async getPortal(config?: AxiosRequestConfig): Promise<IBillingPortalResponse> {
    const response: AxiosResponse<IBillingPortalResponse> = config
      ? await axiosApiInstance.post('/billing/portal', undefined, config)
      : await axiosApiInstance.post('/billing/portal');
    return response.data;
  }
}

export { BillingApi };
